export default __webpack_public_path__ + "static/media/Mercado-Pago-Logo.69198568.png";